/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Unlink_Confirm_TelegramInputs */

const he_account_delivery_unlink_confirm_telegram = /** @type {(inputs: Account_Delivery_Unlink_Confirm_TelegramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לנתק את הטלגרם?`)
};

const en_account_delivery_unlink_confirm_telegram = /** @type {(inputs: Account_Delivery_Unlink_Confirm_TelegramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlink Telegram?`)
};

/**
* | output |
* | --- |
* | "Unlink Telegram?" |
*
* @param {Account_Delivery_Unlink_Confirm_TelegramInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_unlink_confirm_telegram = /** @type {((inputs?: Account_Delivery_Unlink_Confirm_TelegramInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Unlink_Confirm_TelegramInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_unlink_confirm_telegram(inputs)
	return en_account_delivery_unlink_confirm_telegram(inputs)
});